import { render, staticRenderFns } from "./code-display-dialog.vue?vue&type=template&id=2c23adc8&scoped=true&"
import script from "./code-display-dialog.vue?vue&type=script&lang=js&"
export * from "./code-display-dialog.vue?vue&type=script&lang=js&"
import style0 from "./code-display-dialog.vue?vue&type=style&index=0&id=2c23adc8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c23adc8",
  null
  
)

export default component.exports